<template>
  <div class="core-business">
    <div class="container">
      <!-- 左侧菜单 -->
      <div class="side-menu">
        <div class="menu-item" :class="{ active: activeMenu === 'info' }" @click="setActiveMenu('info')">
          信息化项目造价咨询
        </div>
        <div class="menu-item" :class="{ active: activeMenu === 'project' }" @click="setActiveMenu('project')">
          工程项目造价咨询
        </div>
        <div class="menu-item" :class="{ active: activeMenu === 'process' }" @click="setActiveMenu('process')">
          信息化全过程咨询
        </div>
        <div class="menu-item" :class="{ active: activeMenu === 'engineering' }" @click="setActiveMenu('engineering')">
          工程咨询
        </div>
      </div>
      <!-- 右侧内容区 -->
      <div class="content">
        <div v-if="activeMenu === 'info'" class="business-content">
          <div class="business-item">
            <h3>信息化项目预算编制</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目结算审计</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目控制价评审</h3>
          </div>
        </div>
        <div v-if="activeMenu === 'project'" class="business-content">
          <div class="business-item">
            <h3>信息化项目预算编制</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目结算审计</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目控制价评审</h3>
          </div>
        </div>
        <div v-if="activeMenu === 'process'" class="business-content">
          <div class="business-item">
            <h3>信息化项目预算编制</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目结算审计</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目控制价评审</h3>
          </div>
        </div>
        <div v-if="activeMenu === 'engineering'" class="business-content">
          <div class="business-item">
            <h3>信息化项目预算编制</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目结算审计</h3>
          </div>
          <div class="business-item">
            <h3>信息化项目控制价评审</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreBusiness',
  data() {
    return {
      activeMenu: 'info'
    }
  },
  methods: {
    setActiveMenu(menu) {
      this.activeMenu = menu
    }
  }
}
</script>

<style scoped lang="scss">
.core-business {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}

.side-menu {
  width: 220px;
  background: #fff;
  border-radius: 2px;

  .menu-item {
    padding: 15px 24px;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;

    &:hover {
      color: #1890ff;
    }

    &.active {
      background: #f0f7ff;
      color: #1890ff;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.content {
  flex: 1;
}

.business-content {
  display: grid;
  gap: 20px;
}

.business-item {
  background: #fff;
  padding: 20px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: normal;
  }
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .side-menu {
    width: 100%;
  }
}
</style> 